import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import React from "react";
import { Host, LocationImage } from "../../models/hostModel";
import locationsService from "services/locationsService";
import {
  Grid,
  Card,
  MenuItem,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  CircularProgress,
} from "@mui/material";
import MDBox from "mdComponents/MDBox";
import MDTypography from "mdComponents/MDTypography";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import MDInput from "mdComponents/MDInput";
import MDButton from "mdComponents/MDButton";
import LocationHours from "controls/LocationHours";
import LocationDoorLockHours from "controls/LocationDoorLockHours";
import Switch from "@mui/material/Switch";
import { amenityKeyMap, states, amenitiesList, BACKEND_BASE_URL, HOST_PRICING_PLANS, MESSAGES_VALIDATION, MESSAGES_ERROR, MESSAGES_ADDRESS_VERIFICATION } from "../../constants";
import GoingWorkflowService from "services/goingWorkflowService";
import ClearLocationModal from "components/Modals/ClearLocationModal";
import { useHostPortalContext } from "context/HostPortalContext";
import { useNavigationMessageContext } from "context/NavigationMessageContext";
import RemoveLocationModal from "components/Modals/RemoveLocationModal";
import { getCurrentSessionToken } from "services/auth";
import MDAlert from "mdComponents/MDAlert";
import LocationChangeSubscriptionPlanModal from "controls/LocationChangeSubscriptionHostingPlan";
import LocationHostAdminDetailsModal from "controls/LocationHostAdminDetailsModal";
import CorporateAdminList from "controls/CorporateAdminsList";
import corporateAccountService from "services/corporateAccountService";
import { LocationHostUser } from "../../models/locationHostUserModel";
import { useUser } from "context/UserContext";
import CorporateRatings from "controls/CorporteRatings";
import CorporateROI from "controls/CorporateROI";
import CorporateVisits from "controls/CorporateVisits";
import CorporateHostPerformance from "controls/CorporatePerformance";
import CorporateDoorLockIssues from "controls/CorporateDoorLockIssues";
import CorporatePoorConditionReports from "controls/CorporatePoorConditionReportCount";
import { validatePhone } from "Utils";
import googleAPIService from "services/googleAPIService";
import { parseAddress } from "Utils";
import exceptionService from "services/exceptionService";
import AddressPickerModal from "components/Modals/AddressPickerModal";
import AddressNotBusinessVerifyModal from "components/Modals/AddressVerifyModal";
import { formatPhoneNumber } from "Utils";
import { useAlertContext } from "context/AlertContext";
import { LocationCouponManager, LocationPhotoManager } from "controls/LocationMediaManagers";

export default function EditHost() {
  const { id } = useParams<{ id: string }>();
  const { userCorporateAccount} = useUser();
  const { host , setHost } = useHostPortalContext();
  const { setMessage } = useNavigationMessageContext();
  const { setAlert } = useAlertContext();
  const navigate = useNavigate();
  const [showClearLocationModal, setShowClearLocationModal] = useState(false);
  const [showRemoveLocationModal, setShowRemoveLocationModal] = useState<boolean>(false);
  const [showLocationChangeSubscriptionPlanModal, setShowLocationChangeSubscriptionPlanModal] = useState<boolean>(false);    
  const [showLocationAdminDetailsModal, setShowLocationAdminDetailsModal] = useState<boolean>(false);    
  const [locationHostUsers, setLocationHostUsers] = useState<LocationHostUser[]>();
  const [saving, setSaving] = useState(false);
  const [loadingHostUsers, setLoadingHostUsers] = useState(true);
  const [showItemDetails, setShowItemDetails] = useState(false);
  const [showNewItem, setShowNewItem] = useState(false);
  const [viewingItem, setViewingItem] = useState<LocationHostUser>();

  const [updatingHostingPlan, setUpdatingHostingPlan] = useState<boolean>(false);

  const [cancelingMembership, setCancelingMembership] = useState(false);
  const [clearingRestroom, setClearingRestroom] = useState(false);
  const [showAddressNotBusinessVerifyModal, setShowAddressNotBusinessVerifyModal] = useState(false);
  const [showAddressPickerModal, setShowAddressPickerModal] = useState(false);
  const [errors, setErrors] = useState<any>({});
  const [addressesForPicker, setAddressesForPicker] = useState<any[]>([]);
  const [addressPicked, setAddressPicked] = useState<number | null>(null);
  const [addressConfirmed, setAddressConfirmed] = useState(false);
  const [verifingAddress, setVerifingAddress] = useState<boolean>(false);
  
  //if the host was not set in context, fetch it
  useEffect(() => {
    if (id && !host) {
      const hostId = parseInt(id, 10);
      locationsService.getHostRecord(hostId).then((data) => {
        setHost(data);
      });
    }
  }, [id]);

  useEffect(() => {    
        setMessage(`Manage ${host?.name} Hosting Setings`);
        loadLocationUserHosts();
        return () => setMessage(undefined);
  },[host]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value, type, checked } = e.target as HTMLInputElement;
    setHost({
      ...host,
      [name]: type === "checkbox" ? checked : value,
    } as Host);
  };

    const toggleAmenity = (amenityKey: string) => {
    const hostProp = amenityKeyMap[amenityKey];
    if (!hostProp) return;

    setHost((prev: Host) => ({
        ...prev,
        [hostProp]: !prev[hostProp],
    }));
    };

    const handleAddressNotBusinessModalAccept = async() => {
        doTheSave();
    };

     const handleOnAddressPicked = async(id: number) => {
        if (id != null) {
            //get the address from the modal and reverify
            setAddressPicked(id);            
            //hide modal
            setShowAddressPickerModal(false);
            //verify the address
            const newAddy = addressesForPicker?.find(a => a.id == id);            
             if(newAddy != null){
                setHost({
                  ...host,
                  address: newAddy.address,
                  city: newAddy.city,
                  state: newAddy.state,
                  zip: newAddy.zip,
                  placeId: newAddy.placeId,
                  latitude: newAddy.latitude,
                  longitude: newAddy.longitude,
                  isBusiness: newAddy.isBusiness,                  
                });
                setAddressConfirmed(true);
                if(!newAddy.isBusiness)
                    setShowAddressNotBusinessVerifyModal(true);
                else
                    doTheSave();
            }
        }
    };

    const validateBusinessInfo = () => {
        const newErrors: { [key: string]: string } = {};
        if (!host.name) newErrors.name = MESSAGES_VALIDATION.VALIDATION_REQUIRED_BUSINESS_NAME;
        if (!host.address) newErrors.address = MESSAGES_VALIDATION.VALIDATION_REQUIRED_ADDRESS;
        if (!host.city) newErrors.city = MESSAGES_VALIDATION.VALIDATION_REQUIRED_CITY;
        if (!host.state || host.state == 'State') newErrors.state = MESSAGES_VALIDATION.VALIDATION_REQUIRED_STATE;
        if (!host.zip) newErrors.zip = MESSAGES_VALIDATION.VALIDATION_REQUIRED_ZIP;
        if (!host.phone){
            newErrors.phone = MESSAGES_VALIDATION.VALIDATION_REQUIRED_PHONE_NUMBER;
        }else{
            if (!validatePhone(host.phone)) newErrors.phone = MESSAGES_VALIDATION.VALIDATION_PHONE_NUMBER;
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const verifyAddress = () => {
      try {
            const newErrors: { [key: string]: string } = {};
            if (!host.address) newErrors.address = MESSAGES_VALIDATION.VALIDATION_REQUIRED_ADDRESS;
            if (!host.city) newErrors.city = MESSAGES_VALIDATION.VALIDATION_REQUIRED_CITY;
            if (!host.state || host.state == 'State') newErrors.state = MESSAGES_VALIDATION.VALIDATION_REQUIRED_STATE;
            if (!host.zip) newErrors.zip = MESSAGES_VALIDATION.VALIDATION_REQUIRED_ZIP;
            setErrors(newErrors);

            if(!host.address || !host.city || !host.state || !host.zip){
                return false;
            }
            setVerifingAddress(true);
        
            const addressToVerify = {
                address: {
                    regionCode: "US",
                    addressLines: [host.address, host.city + ' ' + host.state + ' ' + host.zip],  
                }
            } 
            //verify the address
            googleAPIService.verifyAddress(addressToVerify).then((result)=> {
                  if (result.addressConfirmed) {
                    if (result.isPOBox) {
                      setAlert("error", MESSAGES_ADDRESS_VERIFICATION.ADDRESS_VERIFICATION_POBOX_NOT_ALLOWED);
                      setAddressConfirmed(false);
                      return;
                    }
                    
                    const { street, city: cityVerified, state: stateVerified, zip: zipVerified, country, longitude, latitude, placeId } = parseAddress(result.formattedAddress);
            
                    if (host.address !== street || host.city !== cityVerified || host.state !== stateVerified || host.zip !== zipVerified) {
                      // show address picker
                      setAddressPicked(2);
                      setAddressesForPicker([
                        //{ id: 1, name: 'Entered Address', address, city, state: stateValue, zip, longitude, latitude, placeId: '', isBusiness: false },
                        {
                          id: 2,
                          name: 'Verified Address',
                          address: street,
                          city: cityVerified,
                          state: stateVerified,
                          zip: zipVerified,
                          country,
                          longitude: result.location.longitude,
                          latitude: result.location.latitude,
                          placeId,
                          isBusiness: result.isBusiness || !result.isResidential,
                        },
                      ]);
                      setShowAddressPickerModal(true);
                      return;
                    } else {
                        //address is good   
                        setHost({
                          ...host,
                          address: result.formattedAddress.slice(0, result.formattedAddress.indexOf(',')),
                          city: cityVerified,
                          state: stateVerified,
                          zip: zipVerified,
                          placeId: result.placeId,
                          latitude: result.location.latitude,
                          longitude: result.location.longitude,
                          isBusiness: result.isBusiness,                  
                        });
                        setAddressConfirmed(true);
                        
                        if(!result.isBusiness)
                           setShowAddressNotBusinessVerifyModal(true);
                        else
                           doTheSave();
                    }
                  } else {
                        setAddressConfirmed(false);
                        setAlert("error", MESSAGES_ADDRESS_VERIFICATION.ADDRESS_VERIFICATION_NOT_ABLE_TO_CONFIRM_ADDRESS);
                  }
            });
            

      } catch (error) {
        exceptionService.logError(error, 'AddLocationMD.verifyAddress');
        setAlert("error", 'There was a problem verifying the address: ' + error.message);
      } finally {
        setVerifingAddress(false);
      }
    };
    
    const handleSave = async () => {
    //verify address
    if(!validateBusinessInfo()) return;
    //save will be called if the address is verified
    verifyAddress();
  };

    const doTheSave = async () => {
      const result = await locationsService.updateLocationSettingsObject(host);
        if(result){
            setAlert("success", 'Location Saved Successfully!');
        }else{
            setAlert("error", 'There was an error saving the location. Please try again.');
        }
    };

    const toggleClosedForCleaning = async () => {
        const result = await locationsService.updateOpenCloseLocation(host.id, !host.closedForCleaning);
        if(result){ 
          setHost((prev) => ({
              ...prev,
              closedForCleaning: !prev.closedForCleaning,
          }) as Host);   

          setAlert(host.closedForCleaning ? "success" : "warning", !host.closedForCleaning ? "Location is now closed for cleaning." : "Location has been re-opened.", !host.closedForCleaning ? "Location Closed" : "Location Re-Opened", host.closedForCleaning ? "check" : "warning");
        }else{
          setAlert("error", "There was an error updating the location status. Please try again.");
        }
  };

  const handleChangePlan = () => {
    setShowLocationChangeSubscriptionPlanModal(true);
  };

  const handleCancel = () => {
    window.history.back();
  };

  const onLocationImagesChanged = (images: LocationImage[]) => {
    const primaryImage = images.find((image) => image.isPrimary);
    setHost((prev) => ({
      ...prev,
      locationImages: images,
      imageuri: primaryImage?.imageUrl ?? prev?.imageuri,
    }) as Host);
  };

  const handleRemoveLocation = () => {
    setShowRemoveLocationModal(true);
  };

  const goToLocationActivity = () => {
    if (!host?.id) return;
    navigate(`/location/activity/${host.id}`);
  };

  const handleClearRestroomConfirm  = async () => {
    const result = await GoingWorkflowService.clearLocationWorkflows(host.id);
    setClearingRestroom(true);
    if(result){
      setAlert("success", "Restroom status cleared. It is now available for app users.");
    }else{
      setAlert('error', 'There was an error clearing the restroom status. Please try again.');
    }
      setClearingRestroom(false);
      setShowClearLocationModal(false);
  };

const handleClearRestroomCancel = () => {
  setShowClearLocationModal(false);
};
  const removeLocationModalCancel = () => {
    setShowRemoveLocationModal(false);
  };
  const removeLocationModalConfirm = () => {
    //set
    setShowRemoveLocationModal(false);  
    //remove the subscription and set the location to not active
    //if free, just remove
    if(host.freeForever){
        //update database
        saveRemoveLocation(new Date());    
      }else{
      cancelSubscription();
    }
  };

  const removeLocationModalChangePricingPlan = () => {
    //set
    setShowRemoveLocationModal(false);  
    //show
    setShowLocationChangeSubscriptionPlanModal(true);
  };

  const cancelSubscription = async() =>{
 try {
      setCancelingMembership(true);
      console.debug('host sub id', host.subscriptionId);
      const response = await fetch(`${BACKEND_BASE_URL}/cancel-subscription`, {
        method: 'POST',
          headers: 
            { 'Content-Type': 'application/json',
              'Authorization': `Bearer ${await getCurrentSessionToken()}`
            },
        body: JSON.stringify({
          subscriptionId: host.subscriptionId,  // Pass the subscription ID
        }),
      });
      const data = await response.json();
      if (data.error) {
        setAlert("Error", "Failed to cancel subscription. Please try again.");
      } else {
        //update database
        saveRemoveLocation(data.cancellationDate);
      }
    } catch (error) {
      setAlert("Error", "Failed to cancel subscription. Please try again.");
    }
    finally{
      setCancelingMembership(false);
    }
  };

    const updateHostingSubcription = async(newHost: any) => {
     try {
          //determine the selected productId
          const planId = HOST_PRICING_PLANS.find(a=> a.id == newHost.hostPremiumOnly ? 2 : 1)?.pricingId;
      
          const response = await fetch(`${BACKEND_BASE_URL}/update-subscription`, {
            method: 'POST',
            headers: 
                { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${await getCurrentSessionToken()}`
                },
            body: JSON.stringify({
              subscriptionId: host.subscriptionId,  // Pass the subscription ID
              newPriceId: planId,
            }),
          });
          const data = await response.json();
          if (data.error) {
            console.debug('Subscription update failed:', data.error);
            setAlert("error", "There was an error updating the hosting plan. Please try again.");
          } else {
            //continue with save
            console.debug(' stripe Subscription updated:', data.message);

            //update the db
            const result = await locationsService.updateLocationSettingsObject(newHost);
            if(result == true){
              setHost(newHost);
              setAlert("success", "Hosting Plan Changed Successfully!");
            }else{
              setAlert("error", "There was an error updating the hosting plan. Please try again.");
            }
            setUpdatingHostingPlan(false);
          }          
        } catch (error) {
          console.debug('Error updating subscription:', error);
          setAlert("error", "There was an error updating the hosting plan. Please try again.");
        }
        finally{
          setUpdatingHostingPlan(false);
        }
  };


  const saveRemoveLocation = async(cancellationDate: Date) => {
    const result = await locationsService.removeLocation(host.id, cancellationDate)
      if(result == true){
        setAlert("success", "Location Removed Successfully and Associated Subscription has been cancelled!");
        navigate('/locations');
      }
      else{
        setAlert("error", "There was an error removing the location. Please try again.");
      }
  };

  const onShowLocationChangeSubscriptionPlanModalConfirm = (id: number) =>{
    setShowLocationChangeSubscriptionPlanModal(false);
    setUpdatingHostingPlan(true);
    //update the subscription
    //update host to 'premiumOnly'
    if(id == 1){
      //regular
      if(host.hostPremiumOnly){
        //update host to not premium
        updateHostHostingPlan(false);
      }
    }else{
      //premium
      if(!host.premiumOnly){
        //update host to premium
        updateHostHostingPlan(true);
      }
    }
  };

  const updateHostHostingPlan = async(isNowPremiumOnly: boolean) => {
      const hostToUpdate = {
        ...host,
        hostPremiumOnly: isNowPremiumOnly
      };
      //TODO: Change Subscription in stripe
      const stripeResult = updateHostingSubcription(hostToUpdate);      
  };

      const loadLocationUserHosts = async () => {
        try {
            const data = await corporateAccountService.getCorporateAccountLocationHostUsers(userCorporateAccount?.id, host?.id);
            if(data){
              setLocationHostUsers(data);
            }
            setLoadingHostUsers(false);
          } catch (err) {     
            setLoadingHostUsers(false);       
            throw err;
          }
    };

    const deleteHostUser = (hostUser: LocationHostUser) => {
      //delete the host user record
      setSaving(true);
      //call
      doDelete(hostUser.id);
    };

    const doDelete = async(id: number) => {
      try {
          const result = await corporateAccountService.deleteLocationHostUser(id);
          if(result === true){
            setAlert("success", 'Location Host User Deleted Successfully!');
            setViewingItem(undefined);
            loadLocationUserHosts();
          }
          else{
            setAlert("error", 'There was an error deleting the location host user. Please try again.');
          }
          setShowItemDetails(false);
          setShowNewItem(false);          
          setSaving(false);
          setShowLocationAdminDetailsModal(false);
        } catch (err) {     
          setSaving(false);       
          throw err;
        }
    };
    
    const updateHostUser = (newHostUser: LocationHostUser) => {
      if(!/\S+@\S+\.\S+/.test(newHostUser.email)){
        setAlert("error", MESSAGES_VALIDATION.VALIDATION_EMAIL);
        return;
      }
      setSaving(true);
      //save the updated email on the record
      doSaveLocationHostUser(newHostUser, true);
    };
    const insertHostUser = (newHostUser: LocationHostUser) => {
      if(!/\S+@\S+\.\S+/.test(newHostUser.email)){
        setAlert("error", MESSAGES_VALIDATION.VALIDATION_EMAIL);
        return;
      }

      setSaving(false);
      //save
      doSaveLocationHostUser(newHostUser, false);
    };
    

    const doSaveLocationHostUser = async(newHostUser: LocationHostUser, isUpdate: boolean) => {
      try {
 
        let result = false;
          if(isUpdate){
            result = await corporateAccountService.updateLocationHostUser(newHostUser.id, newHostUser.email);             
          }
          else{
            const useNewSaveHostUser: LocationHostUser = {
              id: -1,
              created_at: null,
              email: newHostUser.email,
              hostId: host?.id,
              corporateAccountId: userCorporateAccount?.id,
              corporateOwnerUserId: userCorporateAccount?.ownerUserId
            };
            result = await corporateAccountService.insertLocationHostUser(useNewSaveHostUser);
          }
          if(result === true){
            setAlert("success", isUpdate ? 'Location Host User Updated Successfully!' : 'Location Host User Added Successfully!');
            setViewingItem(undefined);
            setShowItemDetails(false);
            setShowNewItem(false);
            setShowLocationAdminDetailsModal(false);
            loadLocationUserHosts();
          }
          else{
            setAlert("error", isUpdate ? MESSAGES_ERROR.ERROR_UPDATING_CORPORATE_ACCOUNT_HOST_USERS : MESSAGES_ERROR.ERROR_INSERTING_CORPORATE_ACCOUNT_HOST_USERS);
          }
          setSaving(false);
        } catch (err) {     
          exceptionService.logError(err, 'EditLocation.doSaveLocationHostUser');
          setAlert("error", isUpdate ? MESSAGES_ERROR.ERROR_UPDATING_CORPORATE_ACCOUNT_HOST_USERS : MESSAGES_ERROR.ERROR_INSERTING_CORPORATE_ACCOUNT_HOST_USERS);
        }
        finally{
          setSaving(false);
        }        
    };

    const onAddHostUser = () => {
    //show a modal to add a record
      setShowNewItem(true);
    };

    
    const onItemSelect = (item: LocationHostUser) => {
      setViewingItem(item);
      setShowLocationAdminDetailsModal(true);
    };

    const onItemDone = () => {
      setShowLocationAdminDetailsModal(false);
      loadLocationUserHosts();
    };
    const onNewItemDone = () => {
      setShowNewItem(false);
      loadLocationUserHosts();
    };



  if (!host) {
    return (
      <DashboardLayout>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6} justifyContent="center">
          <Grid item xs={12} display="flex" justifyContent="center" alignItems="center">
            <Card sx={{ p: 3, display: "flex", flexDirection: "column", alignItems: "center" }}>
              <CircularProgress sx={{ color: "#21b2a6", width: 40, height: 40 }} />
              <MDTypography variant="h6" fontWeight="medium" mt={2}>
                Loading Location...
              </MDTypography>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {/* Actions */}
            <MDBox mt={-3} mb={1}>
                    <MDBox mt={3} py={1} borderRadius="lg">
                        <MDBox display="flex" flexWrap="wrap" gap={2}>
                        <MDButton color="secondary" variant="outlined" onClick={() => navigate(`/location/${host.id}`)}>Back</MDButton>                        
                        {/* <MDButton color="info" onClick={() => goToLocationActivity()}>View Location Activity</MDButton>
                        <MDButton color="info" onClick={() => navigate(`/location/poor-condition-reports/${host.id}`)}>View Poor Condition Reports</MDButton>
                        <MDButton color="info" onClick={() => navigate(`/location/suspended-users/${host.id}`)}>Manage Suspended Users</MDButton> 
                        <MDButton color="dark" onClick={() => setShowClearLocationModal(true)}>Clear Restroom</MDButton>
                        <MDButton color={!host.closedForCleaning ? "warning" : "success"} onClick={() => toggleClosedForCleaning()}>{!host.closedForCleaning ? "Close for Cleaning" : "Re-Open after Cleaning"}</MDButton>*/}
                        </MDBox>
                    </MDBox>
                    <ClearLocationModal
                      open={showClearLocationModal}
                      onConfirm={handleClearRestroomConfirm}
                      onCancel={handleClearRestroomCancel}
                      clearing={clearingRestroom}
                    />
                    {showRemoveLocationModal && 
                    <RemoveLocationModal 
                      onConfirm={removeLocationModalConfirm} 
                      onCancel={removeLocationModalCancel}
                      onChangePricing={removeLocationModalChangePricingPlan} visible={showRemoveLocationModal} isFreeForeverHost={host.freeForever} /> }

                      {showAddressPickerModal && (
                        <AddressPickerModal
                          visible={showAddressPickerModal}
                          currentSelectedAddressId={addressPicked}
                          addresses={addressesForPicker}
                          onAddressPicked={(id: number | null) => {
                              handleOnAddressPicked(id);
                            }
                          }
                          onCancel={() => setShowAddressPickerModal(false)}
                        />
                      )}
                          {showAddressNotBusinessVerifyModal && (
                            <AddressNotBusinessVerifyModal
                              title="Confirm Address"
                              message="This address does not validate as a business. That is okay, but we like to confirm. Things such as parks and churches will show this."
                              visible={showAddressNotBusinessVerifyModal}
                              confirmText="Accept Address"
                              cancelText="Review Address"
                              onConfirm={() => {
                                  setShowAddressNotBusinessVerifyModal(false);
                                  handleAddressNotBusinessModalAccept();      
                              }}
                              onCancel={() => {
                                setShowAddressNotBusinessVerifyModal(false);                                
                              }}
                            />
                          )}
                      

                    {showLocationChangeSubscriptionPlanModal &&
                     <LocationChangeSubscriptionPlanModal
                      visible={showLocationChangeSubscriptionPlanModal}
                      selectedPlanId={host.hostPremiumOnly ? 2 : 1}
                      onCancel={() => setShowLocationChangeSubscriptionPlanModal(false)}
                      onConfirm={onShowLocationChangeSubscriptionPlanModalConfirm}
                    />}
            </MDBox>
            {!host.isApproved &&
              <MDAlert color="secondary" sx={{
                px: 2,               // optional horizontal padding
                fontSize: '0.85rem', // smaller text
                lineHeight: 1.2,     // tighter lines    
              }}>This location is pending approval. Our team will review your
                submission and contact you shortly to verify your business details.</MDAlert>
                }
            {/* Basic Info */}
            <Card>
              <MDBox mx={2} mt={1} py={2} px={2} borderRadius="lg">
                {/* Name */}
                <MDTypography variant="h6" fontWeight="medium">
                    Business Location Information
                </MDTypography>
                <MDBox mb={1}>
                  <MDTypography variant="caption" color="text" mb={1} fontWeight="bold">
                    Name
                  </MDTypography>
                  <MDInput fullWidth name="name" value={host.name} onChange={handleChange} />
                </MDBox>

                {/* Address */}
                <MDBox mb={1}>
                  <MDTypography variant="caption" color="text" mb={1} fontWeight="bold">
                    Address
                  </MDTypography>
                  <MDInput fullWidth name="address" value={host.address} onChange={handleChange} />
                </MDBox>

                {/* City */}
                <MDBox mb={1}>
                  <MDTypography variant="caption" color="text" mb={1} fontWeight="bold">
                    City
                  </MDTypography>
                  <MDInput fullWidth name="city" value={host.city} onChange={handleChange} />
                </MDBox>

                {/* State */}
                <MDBox mb={1}>
                  <MDTypography variant="caption" color="text" mb={1} fontWeight="bold">
                    State
                  </MDTypography>
                    <MDInput
                    select
                    fullWidth
                    name="state"
                    value={host.state || ""}
                    onChange={handleChange}
                    displayEmpty
                    InputProps={{
                        sx: {
                        height: 56,           // total height of input box
                        display: "flex",
                        alignItems: "center",
                        "& .MuiSelect-select": {
                            minHeight: "56px",  // ensures dropdown text vertically centered
                            display: "flex",
                            alignItems: "center",
                        },
                        },
                    }}
                    >
                    <MenuItem value="" disabled>
                        Select a state
                    </MenuItem>
                    {states.map((state) => (
                        <MenuItem key={state.value} value={state.value}>
                        {state.name}
                        </MenuItem>
                    ))}
                    </MDInput>


                </MDBox>

                {/* ZIP */}
                <MDBox mb={1}>
                  <MDTypography variant="caption" color="text" mb={1} fontWeight="bold">
                    ZIP
                  </MDTypography>
                  <MDInput fullWidth name="zip" value={host.zip} onChange={handleChange} />
                </MDBox>

                {/* Phone */}
                <MDBox mb={1}>
                  <MDTypography variant="caption" color="text" mb={1} fontWeight="bold">
                    Phone
                  </MDTypography>
                  <MDInput fullWidth name="phone" value={formatPhoneNumber(host.phone)} onChange={handleChange} />
                </MDBox>
              </MDBox>
            </Card>

            {/* Business Hours */}
            <MDBox mt={3}>
               <Card>
              <MDBox mx={2} mt={1} py={2} px={2} borderRadius="lg">
                    <MDTypography variant="h6" fontWeight="medium" mb={2}>Business Hours</MDTypography>
                        <MDBox display="flex" flexDirection="column" gap={2}>
                            <LocationHours
                                editMode={true}
                                is24Hours={host.is24Hours}
                                setIs24Hours={(value) => setHost((prev) => ({ ...prev, is24Hours: value }))}
                                currentHours={host.hours}
                                saveHours={(hours) => setHost((prev) => ({ ...prev, hours }))}
                            />
                            {host.is24Hours && 
                                <MDTypography variant="caption" color="info" fontWeight="medium">
                                    Location is set to Open 24 Hours - toggle off to set specific business hours.
                                </MDTypography>
                            }
                        </MDBox>
                </MDBox>
                </Card>
            </MDBox>


{/* Hosting Settings */}
<MDBox mt={3}>
  <Card>
    <MDBox mx={2} mt={1} py={2} px={2} borderRadius="lg">
      <MDTypography variant="h6" fontWeight="medium" mb={2}>
        Hosting Settings
      </MDTypography>

      {host.freeForever ? (
        <MDTypography variant="caption" color="success" fontWeight="medium">
          This location is Free Forever — visible to all app users.
        </MDTypography>
      ) : (
        <>
        <FormControl component="fieldset" disabled>
          <RadioGroup
            row
            name="hostingType"
            value={host.hostPremiumOnly ? "true" : "false"} // convert boolean to string
            onChange={(e) =>
              setHost({
                ...host,
                hostPremiumOnly: e.target.value === "true", // convert string back to boolean
              } as Host)
            }
          >
            <FormControlLabel
              value="false"
              control={<Radio />}
              label="Host All Users - $9.99 USD per month"
            />
            <FormControlLabel
              value="true"
              control={<Radio />}
              label="Host Premium Users Only - $19.99 USD per month"
            />
          </RadioGroup>
        </FormControl>
        
        <MDBox display="flex" alignItems="center" p={1}>
            <MDTypography variant="caption" color="error" fontWeight="medium">
            Changing your hosting settings will update your subscription plan automatically!
            </MDTypography>
        </MDBox>
        {updatingHostingPlan && (
            <MDBox sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                <CircularProgress />
                <MDTypography sx={{ ml: 2 }}>Updating Hosting Plan...</MDTypography>
            </MDBox>
        )}        
         <MDBox mt={3} display="flex" gap={2}>
            <MDButton variant="gradient" color="info" onClick={handleChangePlan}>
            Change Hosting Plan
            </MDButton>
        </MDBox>
        </>
      )}
    </MDBox>
  </Card>
</MDBox>


<MDBox mt={3}>
  <Card>
    <MDBox mx={2} mt={1} py={2} px={2} borderRadius="lg">
      <MDTypography variant="h6" fontWeight="medium">
        Location Photos
      </MDTypography>
      <MDTypography variant="caption" color="text" fontWeight="regular">
        Upload up to five photos. The primary photo appears on location cards, and app users can swipe through every photo on the public location profile.
      </MDTypography>
      <MDBox mt={2}>
        <LocationPhotoManager
          hostId={host.id}
          onImagesChanged={onLocationImagesChanged}
        />
      </MDBox>
    </MDBox>
  </Card>
</MDBox>

<MDBox mt={3}>
  <Card>
    <MDBox mx={2} mt={1} py={2} px={2} borderRadius="lg">
      <MDTypography variant="h6" fontWeight="medium">
        Coupons
      </MDTypography>
      <MDTypography variant="caption" color="text" fontWeight="regular">
        Upload up to five coupon images for visitors. Include a large, clear barcode on every coupon so staff can quickly scan it from the visitor's phone while they are at this location.
      </MDTypography>
      <MDBox mt={2}>
        <LocationCouponManager hostId={host.id} />
      </MDBox>
    </MDBox>
  </Card>
</MDBox>


            <MDBox mt={3}>            
            <Card>
              <MDBox mx={2} py={3} px={2} borderRadius="lg">
                <MDTypography variant="h6" fontWeight="medium" mb={-1}>
                  Options & Amenities
                </MDTypography>
                <MDTypography variant="caption" color="text" fontWeight="regular">
                    Select all that apply to this location to attract more customers.
                </MDTypography>
                <MDBox display="flex" flexWrap="wrap" mt={1} gap={2}>
                    {amenitiesList.map((amenity) => {
                        const hostField = amenityKeyMap[amenity.key];
                        return (
                        <MDButton
                            key={amenity.key}
                            variant={host[hostField] ? "gradient" : "outlined"}
                            color="info"
                            onClick={() => toggleAmenity(amenity.key)}
                        >
                            {amenity.label}
                        </MDButton>
                        );
                    })}
                    </MDBox>
              </MDBox>
            </Card>
            </MDBox>

{/* Door Lock Settings */}
<MDBox mt={3}>
  <Card>
      <MDBox mx={2} mt={1} py={2} px={2} borderRadius="lg">
      <MDTypography variant="h6" fontWeight="medium" mb={2}>
        Door Lock Settings
      </MDTypography>

      <MDBox display="flex" flexDirection="column" gap={2}>
        {/* Require Door Lock */}
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <MDTypography sx={{ fontSize: "0.875rem", fontWeight: 400, color: "text.primary" }}>
                Require Door Lock Code for Entry?
          </MDTypography>
          <Switch
            checked={host.doorLockCodeRequired}
            onChange={(e) => setHost((prev) => ({ ...prev, doorLockCodeRequired: e.target.checked }))}
            color="info"
          />
        </MDBox>

        {/* Conditional Fields */}
        {host.doorLockCodeRequired ? (
          <>
            {/* Door Lock Code */}
           <MDBox>
            <MDTypography variant="caption" color="text" mb={1} fontWeight="bold">
                Door Lock Code
            </MDTypography>
            <MDInput
                fullWidth
                name="doorLockCode"
                value={host.doorLockCode || ""}
                onChange={handleChange}
            />
            <MDTypography variant="caption" color="text" fontWeight="regular" mt={0.5}>
                App users will enter this code into the keypad to unlock the restroom.
            </MDTypography>
            </MDBox>

            {/* Time Per Visit */}
            <MDBox>
              <MDTypography variant="caption" color="text" mb={1} fontWeight="bold">
                Time per Visit (minutes)
              </MDTypography>
              <MDInput
                fullWidth
                name="timePerVisit"
                value={host.timeAllowed || ""}
                onChange={handleChange}
              />
                <MDTypography variant="caption" color="text" fontWeight="regular" mt={0.5}>
                    The time in minutes that an app user is allowed to use the restroom before the app warns them.
                </MDTypography>
            </MDBox>

            {/* QR Reader */}
            <MDBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            >
            <MDTypography sx={{ fontSize: "0.875rem", fontWeight: 400, color: "text.primary" }}>Door Lock Uses QR Reader</MDTypography>
            <Switch
            checked={host.useQRCode}
            onChange={(e) => setHost((prev) => ({ ...prev, useQRCode: e.target.checked }))}
            color="info"
            />
            </MDBox>
            <MDTypography variant="caption" mt={-3}> If you have a QR code reader installed on your door lock, enable this option.</MDTypography>


            <MDBox display="flex" flexDirection="column" gap={2}>
                <LocationDoorLockHours
                    editMode={true}
                    doorLockAlwaysLocked={host.doorLockAlwaysLocked}
                    setDoorLockAlwaysLocked={(value) => setHost((prev) => ({ ...prev, doorLockAlwaysLocked: value }))}
                    currentHours={host.doorLockHours}
                    saveHours={(hours) => setHost((prev) => ({ ...prev, doorLockHours: hours }))}
                />
                 {host.doorLockAlwaysLocked && 
                    <MDTypography variant="caption" color="info" fontWeight="medium" mt={-3}>
                        Location always requires door lock code - toggle off to set specific door lock hours.
                    </MDTypography>
                }
            </MDBox>
          </>
        ) : (
            <MDTypography variant="caption" color="error" fontWeight="medium" p={0}>
                No door lock is required — app users will not be required to take a post-use picture.
            </MDTypography>
        )}
      </MDBox>
    </MDBox>
  </Card>
</MDBox>


            <Card sx={{ mt: 3 }}>
              <MDBox mx={2} px={2} borderRadius="lg">
                <CorporateAdminList
                    title="Location Host Admins"
                    description="Manage admin access for this location. Pappa Squat user accounts registered with one of these email addresses will have access to all settings for this location."
                    noRecordsMessage="No location host admins have been added."
                    admins={locationHostUsers} shadow={false}
                    onAddAdmin={()=> setShowLocationAdminDetailsModal(true)}
                    onRemoveAdmin={deleteHostUser}
                    onEditAdmin={onItemSelect}
                     />
                </MDBox>
            </Card>
            {showLocationAdminDetailsModal &&
              <LocationHostAdminDetailsModal
                  visible={showLocationAdminDetailsModal}
                  selectedItem={viewingItem}
                  editMode={viewingItem != undefined}
                  onSaveChanges={viewingItem == undefined ? insertHostUser : updateHostUser}
                  onDelete={deleteHostUser}
                  onDone={() => setShowLocationAdminDetailsModal(false)}
              />
            }
            


            {/* Save / Cancel */}
<MDBox mt={3} display="flex" alignItems="center" gap={2}>
  {/* Left side buttons */}
  <MDButton variant="outlined" color="secondary" onClick={handleCancel}>
    Cancel / Done
  </MDButton>
  <MDButton variant="gradient" color="info" onClick={handleSave}>
    Save Changes
  </MDButton>

  {/* Right side button */}
  <MDButton
    color="dark"
    onClick={handleRemoveLocation}
    sx={{ marginLeft: "auto" }}
  >
    Remove Location
  </MDButton>
</MDBox>



          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
